import { Translation } from '@dxp-module/common'
import { FunctionComponent } from 'react'
import { Box } from '@mui/material'
import { Link } from 'react-router-dom'
import signInUpLinkStyles from './signInUpLink.styles'

type SignInUpLinkProps = {
  textId: string
  linkId: string
  path: string
  testId: string
}
const SignInUpLink: FunctionComponent<SignInUpLinkProps> = ({
  textId,
  linkId,
  path,
  testId,
}) => {
  const styles = signInUpLinkStyles()

  return (
    <Box className={styles.container}>
      <Translation
        component="Typography"
        componentProps={{ variant: 'body1' }}
        id={textId}
        className={styles.text}
        data-test={`${testId}:text`}
      />
      <Link to={path}>
        <Translation
          component="Typography"
          componentProps={{ variant: 'body1' }}
          id={linkId}
          className={styles.link}
          data-test={`${testId}:link`}
        />
      </Link>
    </Box>
  )
}

export default SignInUpLink
